var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4935 15.9307V8.46582L21.0873 8.93457V15.9307C20.2128 16.2251 19.5811 17.0522 19.5811 18.0246V21.7902C19.5811 22.1785 19.8959 22.4934 20.2842 22.4934H23.2966C23.685 22.4934 23.9998 22.1785 23.9998 21.7902V18.0246C23.9998 17.0522 23.368 16.2251 22.4935 15.9307Z",
    fill: "#60B984"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 11.7412L4.51855 9.46973V14.2588C4.51855 14.4453 4.59266 14.6241 4.72452 14.756C6.66805 16.6993 9.25195 17.7695 12.0001 17.7695C14.7484 17.7695 17.332 16.6993 19.2751 14.7559C19.407 14.624 19.4811 14.4452 19.4811 14.2588V9.46973L12.6668 11.7411C12.201 11.8963 11.7321 11.8742 11.333 11.7412Z",
    fill: "#60B984"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.4433C12.0751 10.4433 12.1502 10.4312 12.2223 10.4072L23.5192 6.64157C23.8063 6.54585 24 6.27716 24 5.97454C24 5.67191 23.8064 5.40322 23.5192 5.3075L12.2223 1.54189C12.078 1.49385 11.922 1.49385 11.7777 1.54189L0.480797 5.3075C0.193641 5.40318 0 5.67186 0 5.97454C0 6.27721 0.193641 6.54585 0.480797 6.64157L11.7777 10.4072C11.8498 10.4312 11.9249 10.4433 12 10.4433Z",
    fill: "#60B984"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversities);
export default __webpack_public_path__ + "static/media/universities.3092aaf1a703cbc997289622f9510a33.svg";
export { ForwardRef as ReactComponent };